import {
  ShoppingBasket, Home, Sparkle, HeartPulse, Shirt, Baby,
  Smartphone, Refrigerator, BookOpen, Dumbbell, Wrench, Dog, Package,
  LayoutGrid,
} from "lucide-react";

/**
 * Client-side mirror of the backend SHOP_CATEGORIES taxonomy.
 * Kept in sync manually — if you change the backend list, mirror it here.
 * Order controls the render order on the shop rail.
 */
export const SHOP_CATEGORY_ICONS = {
  ShoppingBasket, Home, Sparkle, HeartPulse, Shirt, Baby,
  Smartphone, Refrigerator, BookOpen, Dumbbell, Wrench, Dog, Package,
};

export const ALL_CATEGORIES_ICON = LayoutGrid;

export function iconForCategory(iconName) {
  return SHOP_CATEGORY_ICONS[iconName] || Package;
}
